export default "__VITE_ASSET__cbb8dd5f__"